import { Button, Result, Spin, Tabs } from 'antd';
import React, { FC, useEffect, useRef, useState } from 'react';
import { WebUxPage, WebUxPageContent, WebUxPageItem } from '../../webux-layouts/WebUxPage';
import { useConnection } from '../../../../connection/Application';
import { useHistory, useParams } from 'react-router-dom';
import { CycleToggle } from '../../../../components/atoms/ItemToggle';
const { TabPane } = Tabs;

import './goal.less';
import { GoalsPageForTeam } from './GoalsPageForTeam';
import { useQueryParam } from 'use-query-params';
import { PageHeader } from '@ant-design/pro-layout';

const GoalsPage: FC = () => {
  const [loading, setLoading] = useState<any>(false);
  const [data, setData] = useState<
    {
      total: number;
      goals: any[];
      parentTeams: number;
      approvalStatus: string;
      goalSummaryId: number;
      goalsAvailability: boolean;
      teamName: string;
      teamId: number;
      cyclePercentage: number;
      configurations: any[]; // percentage
    }[]
  >([]);

  const [cycle, setCycle] = useQueryParam<number | undefined>('cycle');
  const cycleRef = useRef(cycle);
  const [performanceCycles, setPerformanceCycles] = useState<any[]>([]);
  const [fetching, setFetching] = useState<boolean>(false);
  const [goalSummary, setGoalSummary] = useState<number>();
  const [cycleMap, setCycleMap] = useState<
    Record<number, { id: string; name: string; ownerId: number }>
  >({});
  const [error, setError] = useState<any>();
  const connection = useConnection();
  const params = useParams<{
    type: string;
    id: string;
    name: string;
    oid: string;
    tid: string;
  }>();
  const history1 = useHistory();

  useEffect(() => {
    const token = connection.hasSession();
    if (token) {
      connection.get('cycles').then(async (value) => {
        setPerformanceCycles(value.performanceCycle);
        if (cycleRef.current === undefined) {
          setCycle(value.closestCycle.id, 'replace');
        }
      });
    }
  }, [connection, setCycle]);

  useEffect(() => {
    setLoading(true);
    if (!!cycle && !!params?.type) {
      setError(undefined);
      connection
        .get(
          params?.type
            ? `goals/tree/get/${params?.id}/${cycle ?? 0}`
            : `goals/tree/get/${isNaN(cycle) ? 0 : cycle}`,
        )
        .then((value: { response: any[] }) => {
          console.log(value.response);
          setData(value.response);
          if (params?.type === 'team' && value.response?.[0]?.cycleMap) {
            setCycleMap((prev) => ({ ...prev, ...value.response[0].cycleMap }));
          }
        })
        .catch((e) => setError(e))
        .finally(() => setLoading(false));
    }
  }, [connection, cycle, params, fetching]);

  return (
    <>
      {error ? (
        <Result
          status="403"
          title="403"
          subTitle="Sorry, you are not authorized to access this page."
          extra={
            <Button onClick={() => history1.push('/webux/my-goals')} type="primary">
              Back To Home
            </Button>
          }
        />
      ) : (
        <WebUxPage>
          <PageHeader
            ghost={false}
            style={{ background: '#FFF' }}
            title={`${decodeURIComponent(params?.name ?? '')}'s Objectives`}
            subTitle="Manage Objectives details"
            onBack={() => history1.push(`/webux/my-goals?cycle=${cycle}`)}
            breadcrumb={{
              items: [
                {
                  path: 'goals',
                  title: `Objectives ${
                    params?.type
                      ? `/ ${params?.type === 'user' ? 'Employee' : 'Team'} / ${decodeURIComponent(
                          params?.name ?? '',
                        )} `
                      : ''
                  }`,
                },
              ],
            }}
          />
          <WebUxPageContent>
            <WebUxPageItem>
              {performanceCycles && (
                <CycleToggle
                  value={parseInt(`${cycle}`)}
                  onChange={(value) => {
                    if (params.type === 'team' && value && cycleMap[value]) {
                      history1.push(
                        `/webux/my-goals/goals/team/${cycleMap[value].ownerId}/${cycleMap[value].name}?cycle=${value}`,
                      );
                    } else {
                      setCycle(value, 'replace');
                    }
                  }}
                  data={performanceCycles}
                />
              )}
              <Spin spinning={loading}>
                {data?.length > 1 && (
                  <Tabs
                    defaultActiveKey={
                      data.find((e) => e.teamId === +params?.tid ?? 0)?.goalSummaryId + '' ?? '1'
                    }
                    onChange={(e) => setGoalSummary(+e)}>
                    {data.map((e) => (
                      <TabPane tab={e.teamName} key={e.goalSummaryId}>
                        <GoalsPageForTeam
                          setLoading1={setLoading}
                          performanceCycles={performanceCycles}
                          currentCycleValue={cycle ?? 0}
                          focus={!goalSummary || goalSummary === e.goalSummaryId}
                          value={e}
                          reload={() => setFetching(!fetching)}
                          totalCyclePercentage={e.goals.reduce(
                            (preVal, currentVal) => preVal + currentVal,
                            0,
                          )} // total collection of cycle precentage
                        />
                      </TabPane>
                    ))}
                  </Tabs>
                )}
                {data?.length == 1 && (
                  <GoalsPageForTeam
                    setLoading1={setLoading}
                    performanceCycles={performanceCycles}
                    currentCycleValue={cycle ?? 0}
                    value={data[0]}
                    focus={!goalSummary || goalSummary === data[0].goalSummaryId}
                    reload={() => setFetching(!fetching)}
                    totalCyclePercentage={data[0].cyclePercentage}
                  />
                )}
                {data?.length == 0 && (
                  <GoalsPageForTeam
                    setLoading1={setLoading}
                    performanceCycles={performanceCycles}
                    currentCycleValue={cycle ?? 0}
                    focus={true}
                    value={{
                      total: 0,
                      goals: [],
                      parentTeams: 0,
                      approvalStatus: '',
                      goalSummaryId: 0,
                      goalsAvailability: false,
                    }}
                    reload={() => setFetching(!fetching)}
                  />
                )}
              </Spin>
            </WebUxPageItem>
          </WebUxPageContent>
        </WebUxPage>
      )}
    </>
  );
};

export default GoalsPage;
